import React from 'react';
import { ServicesHero } from '../components/services/ServicesHero';
import { ServicesGrid } from '../components/services/ServicesGrid';
import { WhyChooseUs } from '../components/services/WhyChooseUs';

export const ServicesPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <ServicesHero />
      <ServicesGrid />
      <WhyChooseUs />
    </div>
  );
};
